import { Grid } from '@material-ui/core';
import {
  Button,
  Pagination,
  PaginationNumbers,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal from 'components/Modal';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ClassesCard from './ClassesCard';
import NewClasses from './NewClasses';
import Nodata from 'components/NoData';
import theme from '../theme';
import ClassesCardSkeleton from './ClassesCardSkeleton';

const Result = ({
  allClasses,
  size,
  onPaginationChange,
  page,
  refetch,
  totalElements,
  handleOpenExportModal,
  isLoading
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);
  const intl = useIntl();

  const [openCreateClasses, setOpenCreateClasses] = useState(false);
  const {
    images: { Records }
  } = theme

  const goToListInviteStudent = () => {
    push(ROUTES_PATH.SCHOOL_INVITE_STUDENT);
  };

  const handleOpenCreateClasses = () => {
    setOpenCreateClasses(true);
  };

  const handleCloseCreateClasses = () => {
    setOpenCreateClasses(false);
  };


  return (
    <div className={cx(classes.container)}>


      {
        isLoading ? (
          <Grid
            container
            style={{
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
              padding: spacing(0, 0, 2.5, 2.5),
              // marginBottom: spacing(2.5),
            }}
          >
            {[...Array(size/2)].map((_, idx) => (
              <Grid item xs={12} md={4} lg={3} style={{ padding: spacing(2.5, 2.5, 0, 0) }} key={idx}>
                <ClassesCardSkeleton />
              </Grid>
            ))}
          </Grid>
        ) :
          !allClasses?.length ? (
            <Grid item xs={12} className={classes.noDataContainer}>
              <Nodata
                image={Records}
                contentWidth='70%'
                padding='0px 20px 20px 0px'
                title="Aucune classe créée"
                description="Créez votre première classe pour commencer à organiser vos formations et inviter des apprenants."
              />
            </Grid>
          ) : (
            <Grid
              container
              style={{
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
                padding: spacing(0, 0, 2.5, 2.5),
                // marginBottom: spacing(2.5),
              }}
            >
              {allClasses.map(
                ({ endDate, id, label, startDate, training }, index) => (
                  <ClassesCard
                    key={index}
                    endDate={endDate}
                    id={id}
                    label={label}
                    refetch={refetch}
                    startDate={startDate}
                    trainingId={training}
                    handleOpenExportModal={handleOpenExportModal}
                  />
                )
              )}
            </Grid>
          )
      }

      {allClasses.length > 0 && (
        <PaginationNumbers
          onChange={onPaginationChange}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      )}
      <Modal
        nbStep={1}
        onCancel={handleCloseCreateClasses}
        open={openCreateClasses}
        step={1}
        title={intl.formatMessage({
          id: 'school.createClasse.title',
        })}
        withStep={false}
      >
        <NewClasses close={handleCloseCreateClasses} refetch={refetch} />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background: 'white',
    height: '100%',
    borderRadius: '0 0 10px 10px',
  },
  noDataContainer: {
    height: '100%',
  }
});

Result.propTypes = {
  allClasses: PropTypes.array,
  onPaginationChange: PropTypes.func,
  refetch: PropTypes.func,
  page: PropTypes.number,
  totalElements: PropTypes.number,
};

export default Result;
